import { useLocaleKeys } from '~/i18n';
import { useDraftsChipConnector } from './draftsChipConnector';
const PACKAGES_BI = {
    toggle: 'drafts_ai_search_chip_toggle_packages_quantifier',
    remove: 'drafts_ai_search_chip_remove_packages',
    prefix: 'drafts_ai_search_chip_packages_name'
};
const BUNDLES_BI = {
    toggle: 'drafts_ai_search_chip_toggle_bundles_quantifier',
    remove: 'drafts_ai_search_chip_remove_bundles',
    prefix: 'drafts_ai_search_chip_bundles_name'
};
const useDraftsCollectionGrammar = (bi)=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const connector = useDraftsChipConnector();
    return {
        texts: t,
        connector,
        bi
    };
};
export const useDraftsPackagesGrammar = ()=>useDraftsCollectionGrammar(PACKAGES_BI);
export const useDraftsBundlesGrammar = ()=>useDraftsCollectionGrammar(BUNDLES_BI);
